import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";
import { BACKEND_URL, publicApi } from "@/lib/api";

export const shareUrl = (kind, id) => `${BACKEND_URL}/api/s/${kind}/${id}`;

export const ShareButton = ({ kind, id, title, text, compact = false, className = "btn-ghost", style, testId }) => {
  const [done, setDone] = useState(false);
  const url = shareUrl(kind, id);

  const share = async () => {
    publicApi.post("/public/share", { kind, id }).catch(() => {});
    if (navigator.share) {
      try { await navigator.share({ title, text, url }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    try {
      await navigator.clipboard.writeText(url);
      setDone(true);
      toast.success("Link copied — paste it anywhere and the artwork shows up");
      setTimeout(() => setDone(false), 2000);
    } catch {
      window.prompt("Copy this link", url);
    }
  };

  if (compact) {
    return (
      <button type="button" onClick={share} aria-label={`Share ${title}`} title="Share"
              className="inline-flex items-center justify-center transition-colors"
              style={{ width: 34, height: 34, borderRadius: "var(--radius)", border: "1px solid rgba(200,155,60,.3)", color: done ? "var(--gold-lift)" : "var(--parchment)", background: "transparent", cursor: "pointer", ...style }}
              data-testid={testId || `share-${kind}-${id}`}>
        {done ? <Check size={14} /> : <Share2 size={14} />}
      </button>
    );
  }
  return (
    <button type="button" onClick={share} className={className} style={{ padding: ".7rem 1.1rem", ...style }} data-testid={testId || `share-${kind}-${id}`}>
      {done ? <Check size={13} /> : <Share2 size={13} />} {done ? "Copied" : "Share"}
    </button>
  );
};
